<template>
  <div id="detail_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Post Schedule Detail</h5>

          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-12 flexbox-center">
              <div class="of-card" style="width: 100%; max-width: 343px;">
                <div class="of-card-top"></div>
                <div class="of-card-header">
                  <div class="of-card-h-1">
                    <div class="of-card-h-2">
                      <div class="of-card-h-6">
                        <div>
                          <div class="of-card-h-7">
                            <span v-if="row.update_datetime">{{
                              formatLocalDate(row.update_datetime)
                            }}</span>
                          </div>
                          <ul class="tm" :ref="'account-' + row.id">
                            <Skeleton :count="1" />
                          </ul>
                        </div>
                      </div>
                      <div class="text-end">
                        <div class="dropdown dropdown-action">
                          <a
                            href="javascript:void(0)"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i class="material-icons">more_vert</i>
                            <span class="sr-only">Toggle Dropdown</span>
                          </a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <router-link
                              :to="'wizard?id=' + row.id"
                              class="dropdown-item"
                              :disabled="
                                row.is_publish == 0 ||
                                (row.sending_options == 2 &&
                                  row.sending_schedule > currentDateTimeUnix())
                                  ? false
                                  : true
                              "
                            >
                              <i class="fa fa-pencil m-r-5"></i> Edit
                            </router-link>
                            <router-link
                              :to="'wizard?id=' + row.id + '&copy=1'"
                              class="dropdown-item"
                            >
                              <i class="fa fa-copy m-r-5"></i> Copy
                            </router-link>
                            <a
                              href="javascript:void(0)"
                              class="dropdown-item"
                              @click.prevent="showSearchFormSummary(row.id)"
                              data-toggle="modal"
                              data-target="#summary_form"
                              :disabled="
                                row.is_publish == 0 ||
                                  (row.sending_options == 2 &&
                                    row.sending_schedule >
                                      currentDateTimeUnix())
                              "
                            >
                              <i class="la la-eye m-r-5"></i> Statistik
                            </a>
                            <a
                              :disabled="isLoading"
                              href="javascript:void(0)"
                              class="dropdown-item"
                              @click.prevent="actionUpdateStatus('unpublish')"
                            >
                              <i class="la la-pause"></i> Unpublish
                            </a>
                            <a
                              :disabled="isLoading"
                              href="javascript:void(0)"
                              class="dropdown-item"
                              @click.prevent="actionUpdateStatus('publish')"
                            >
                              <i class="la la-check"></i> Publish
                            </a>
                            <a
                              :disabled="isLoading"
                              href="javascript:void(0)"
                              class="dropdown-item"
                              @click.prevent="actionDelete"
                            >
                              <i class="la la-trash"></i> Delete
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="of-card-body">
                  <div class="of-card-body-a">
                    <div class="of-card-body-cap">
                      <div class="of-card-body-cap-1">
                        <p :title="row.caption" class="of-card-body-cap-2">
                          {{ row.caption }}
                        </p>
                      </div>
                    </div>
                    <div class="of-card-body-img">
                      <template v-if="assetsUrl.length > 0">
                        <img
                          v-if="
                            assetsUrl[0].includes('.jpg') ||
                              assetsUrl[0].includes('.jpeg')
                          "
                          title="Lihat Gambar"
                          @click="openImage(assetsUrl)[0]"
                          style="cursor: zoom-in"
                          class="of-card-body-img-p"
                          :src="assetsUrl[0]"
                          :alt="row.caption"
                        />
                        <video
                          style="
                                  width: 100%;
                                  height: 100%;
                                  overflow: hidden;
                                "
                          v-else-if="assetsUrl[0].includes('.mp4')"
                          controls
                        >
                          <source :src="assetsUrl[0]" type="video/mp4" />
                        </video>
                        <img
                          v-else
                          class="of-card-body-img-p"
                          :src="require('@/assets/placeholder.jpg')"
                          alt=""
                        />
                      </template>
                      <template v-else>
                        <img
                          class="of-card-body-img-p"
                          :src="require('@/assets/placeholder.jpg')"
                          alt=""
                        />
                      </template>
                    </div>
                  </div>
                  <div class="of-card-body-b"></div>
                  <div class="of-card-body-c">
                    <table class="of-card-table">
                      <tbody>
                        <tr>
                          <td class="of-card-td-l">Brand</td>
                          <td class="of-card-td-r">
                            <div style="width: 150px" :ref="'brand-' + row.id">
                              <Skeleton :count="1" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <td class="of-card-td-l">Media Type</td>
                          <td class="of-card-td-r">
                            <span class="badge badge-primary">{{
                              row.media_type
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr>
                          <td class="of-card-td-l">Reccuring</td>
                          <td class="of-card-td-r" style="line-height: 19.5px">
                            <template v-if="row.is_recurring == 1">
                              <i class="fa fa-clock-o"></i>
                              {{ row.recurrence }}
                              <span>
                                <br />
                                time:
                                {{
                                  formatHourFromUnix(
                                    convertUTCDatetimeToUnix(
                                      row.recurrence_time
                                    )
                                  )
                                }}
                              </span>
                              <span v-if="row.recurrence != 'daily'">
                                <br />
                                every: {{ row.recurrence_every }}
                                {{ row.recurrence_annually_month }}
                              </span>

                              <br />end:
                              <span v-if="row.recurrence_end == 'never'">{{
                                row.recurrence_end
                              }}</span>
                              <span v-else>{{
                                formatLocalDate(row.recurrence_end_date)
                              }}</span>
                            </template>
                            <template v-else>-</template>
                          </td>
                        </tr>
                      </tbody>
                      <tbody>
                        <tr style="border: none">
                          <td class="of-card-td-l">Status</td>
                          <td class="of-card-td-r" style="line-height: 19.5px">
                            <template v-if="row.is_publish == 0">
                              <span :class="'text text-warning'">
                                <i class="fa fa-pause"></i>
                                DRAFT
                              </span>
                            </template>
                            <template v-if="row.is_publish == 1">
                              <span
                                :class="'text text-success'"
                                v-if="row.sending_options == 1"
                              >
                                <i class="fa fa-check"></i>
                                SENT
                                <br />
                                <small v-if="row.cron_timestamp > 0">{{
                                  timeAgo(row.cron_timestamp)
                                }}</small>
                                <small v-else>
                                  {{ timeAgo(row.update_datetime) }}
                                  <br />(send now)
                                </small>
                              </span>
                              <span
                                :class="'text text-success'"
                                v-if="
                                  row.sending_options == 2 &&
                                    row.sending_schedule < currentDateTimeUnix()
                                "
                              >
                                <i class="fa fa-check"></i>
                                Sent
                                <br />
                                <small v-if="row.cron_timestamp > 0">{{
                                  timeAgo(row.cron_timestamp)
                                }}</small>
                              </span>
                              <span
                                :class="'text text-info'"
                                v-if="
                                  row.sending_options == 2 &&
                                    row.sending_schedule > currentDateTimeUnix()
                                "
                              >
                                <i class="fa fa-clock-o"></i>
                                Scheduled
                                <br />
                                <small>{{
                                  formatLocalDateWithDay(row.sending_schedule)
                                }}</small>
                              </span>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Skeleton } from "vue-loading-skeleton";
import {
  formatLocalDate,
  timeAgo,
  formatLocalDateWithDay,
  formatHourFromUnix,
  convertUTCDatetimeToUnix,
  currentDateTimeUnix
} from "@/utils/helper";
import VueCustomTooltip from "@adamdehaven/vue-custom-tooltip";

export default {
  name: "PostScheduleDetail",
  components: {
    Skeleton,
    VueCustomTooltip
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      row: {},
      assetsUrl: [],
      serverParams: {
        columnFilters: {
          id: ""
        }
      }
    };
  },
  watch: {
    isShowFormSummary: {
      handler: function(val, oldVal) {
        if (val == true) {
          var that = this;
          setTimeout(function() {
            that.clearForm();
            that.serverParams.columnFilters.id = that.isShowFormSummaryId;
            that.getDetailPost();
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    isShowFormSummary() {
      return this.$store.state.instagramSchedule.isShowFormSummary;
    },
    isShowFormSummaryId() {
      return this.$store.state.instagramSchedule.isShowFormSummaryId;
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    showSearchFormSummary(id) {
      this.$router.push(
        `/instagram-official/post/statistik?instagram_schedule_id=${id}`
      );
    },
    openImage(url) {
      window.open(url, "_blank");
    },
    clearForm() {
      this.$refs["account-" + this.row.id].innerHTML = "";
      this.$refs["brand-" + this.row.id].innerHTML = "";
      this.serverParams.columnFilters.id = "";
      this.assetsUrl = [];
      this.row = {};
    },
    async getDetailPost() {
      this.loading = await true;
      await this.$store
        .dispatch("instagramSchedule/listScheduleById", this.serverParams)
        .then(response => {
          const { data } = response;
          this.row = data.data[0];
          this.loading = false;
          console.log(this.row);

          if (this.row) {
            this.assetsUrl = JSON.parse(this.row.assets_url);
            let detailId = this.row.brand_id;
            this.$store.dispatch("brand/detail", detailId).then(responseDet => {
              var resData = responseDet.data;
              this.$refs["brand-" + this.row.id].innerHTML = resData.name;
            });

            if (
              this.row.instagram_account_id != "" &&
              this.row.instagram_account_id != null
            ) {
              let accountArr = JSON.parse(this.row.instagram_account_id);
              console.log(
                "accountArr.length",
                accountArr.length,
                this.row.instagram_account_id
              );
              if (accountArr.length) {
                accountArr.forEach(async (igAccountId, idxAcc) => {
                  await this.$store
                    .dispatch("instagramAccount/detail", igAccountId)
                    .then(responseDet => {
                      var resData = responseDet.data;
                      const serverParams = {
                        columnFilters: {
                          instagram_account_id: igAccountId,
                          brand_id: this.row.brand_id,
                          media_type: this.row.media_type,
                          is_official: "1",
                          instagram_schedule_id: this.row.id
                        }
                      };
                      if (idxAcc > 0) {
                        this.$store
                          .dispatch("instagramSchedule/listLogs", serverParams)
                          .then(response => {
                            const { data } = response;
                            const detailLog = data.data[0];

                            const tooltipComponent = this.$createElement(
                              VueCustomTooltip,
                              {
                                props: {
                                  label: resData.username,
                                  style: "position: relative;"
                                }
                              },
                              [
                                this.$createElement("img", {
                                  attrs: {
                                    src: require("@/assets/user.jpg"),
                                    alt: ""
                                  }
                                }),
                                this.$createElement("i", {
                                  attrs: {
                                    class: `${
                                      detailLog.post_status == 2
                                        ? "la la-check"
                                        : "la la-times"
                                    } ${detailLog.post_status == 1 ||
                                      (Object.keys(detailLog).length == 0 &&
                                        "hidden")}`,
                                    style: `${
                                      detailLog.post_status == 2
                                        ? "color: #55ce63;"
                                        : "color: #e4405f;"
                                    } font-size: 16px; position: absolute; bottom: -6px; right: -10px; font-weight: bold;`
                                  }
                                })
                              ]
                            );

                            const linkElement = this.$createElement(
                              "a",
                              {
                                attrs: {
                                  href: `https://www.instagram.com/${resData.username}/`,
                                  target: "_blank",
                                  style: "margin-right: 6px;"
                                }
                              },
                              [tooltipComponent]
                            );

                            const vm = new Vue({
                              render: h => h("li", [linkElement])
                            });

                            vm.$mount();
                            this.$refs["account-" + this.row.id].innerHTML +=
                              vm.$el.outerHTML;
                          });
                      } else {
                        this.$store
                          .dispatch("instagramSchedule/listLogs", serverParams)
                          .then(response => {
                            const { data } = response;
                            const detailLog = data.data[0];

                            const tooltipComponent = this.$createElement(
                              VueCustomTooltip,
                              {
                                props: {
                                  label: resData.username,
                                  style: "position: relative;"
                                }
                              },
                              [
                                this.$createElement("img", {
                                  attrs: {
                                    src: require("@/assets/user.jpg"),
                                    alt: ""
                                  }
                                }),
                                this.$createElement("i", {
                                  attrs: {
                                    class: `${
                                      detailLog.post_status == 2
                                        ? "la la-check"
                                        : "la la-times"
                                    } ${detailLog.post_status == 1 ||
                                      (Object.keys(detailLog).length == 0 &&
                                        "hidden")}`,
                                    style: `${
                                      detailLog.post_status == 2
                                        ? "color: #55ce63;"
                                        : "color: #e4405f;"
                                    } font-size: 16px; position: absolute; bottom: -6px; right: -10px; font-weight: bold;`
                                  }
                                })
                              ]
                            );

                            const linkElement = this.$createElement(
                              "a",
                              {
                                attrs: {
                                  href: `https://www.instagram.com/${resData.username}/`,
                                  target: "_blank",
                                  style: "margin-right: 6px;"
                                }
                              },
                              [tooltipComponent]
                            );

                            const vm = new Vue({
                              render: h => h("li", [linkElement])
                            });

                            vm.$mount();
                            this.$refs["account-" + this.row.id].innerHTML +=
                              vm.$el.outerHTML;
                          });
                      }
                    });
                });
              }
            } else {
              this.$refs["account-" + this.row.id].innerHTML =
                "failed getting account detail";
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    actionUpdateStatus(statusValue) {
      this.isLoading = true;
      this.$fire({
        title: "Are you sure you want to update status ?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: [this.row.id],
              action: "update_status",
              status: statusValue
            };
            this.$store
              .dispatch("instagramSchedule/actionStore", newParam)
              .then(async response => {
                await this.$fire({
                  title: "Success Update",
                  text: "The data was successfully updated",
                  type: "success",
                  timer: 1000
                });
                this.isLoading = false;
                var elem = this.$refs.dismisModal;
                elem.click();
                this.clearForm();
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      this.isLoading = true;
      this.$fire({
        title: "Are you sure you want to permanently erase ?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: [this.row.id],
              action: "delete"
            };
            this.$storex
              .dispatch("instagramSchedule/actionStore", newParam)
              .then(async response => {
                await this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                var elem = this.$refs.dismisModal;
                elem.click();
                this.clearForm();
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    }
  }
};
</script>

<style scoped>
.flexbox-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.of-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 300px;
  background-color: rgb(255, 255, 255);
  border-color: rgb(222, 225, 225);
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
}
.of-card-top {
  background-color: rgb(228, 64, 95);
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  height: 8px;
}
.of-card-header {
  padding: 8px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-radius: 8px 8px 0px 0px;
  font-size: 13px;
  line-height: 21.3333px;
  border-color: rgb(222, 225, 225);
}
.of-card-h-1 {
  padding: 8px;
  width: 100%;
  /* overflow: hidden; */
}
.of-card-h-2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.of-card-h-3 {
  margin-right: 12px;
}
.of-card-h-4 {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  overflow: hidden;
  display: flex;
  position: relative;
  flex-shrink: 0;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  color: rgb(39, 51, 51);
  background: rgb(222, 225, 225);
}
.of-card-h-5 {
  display: block;
  margin: 0px;
  width: auto;
  height: 100%;
  max-width: 100%;
}
.of-card-h-6 {
  display: flex;
}
.of-card-h-7 {
  margin: 0px;
  padding-left: 0px;
  padding-right: 0px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  color: rgb(54, 65, 65);
  font-size: 13px;
  line-height: 21.3333px;
}
.of-card-h-8 {
  color: rgb(54, 65, 65);
  font-weight: 400;
  font-size: 11px;
  line-height: 18.6667px;
}
.of-card-body {
  padding: 16px;
  font-size: 16px;
  line-height: 24px;
  border-color: rgb(222, 225, 225);
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
}
.of-card-body-a {
  display: flex;
  flex-direction: column;
}
.of-card-body-cap {
  margin-bottom: 12px;
  height: 63.98px;
}
.of-card-body-cap-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
}
.of-card-body-cap-2 {
  font-size: 13px;
  line-height: 21.3333px;
  color: #364141;
}
.of-card-body-img {
  border: 1px solid rgb(222, 225, 225);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  height: 299px;
  background-color: #f7f7f7;
}
.of-card-body-img-p {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  max-width: 100%;
}
.of-card-body-b {
  padding-bottom: 16px;
}
.of-card-body-c {
  display: flex;
}
.of-card-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.of-card-table tbody:first-child td {
  padding-top: 0px;
}
.of-card-table tbody td:first-child {
  padding-left: 0px;
  width: 100%;
  max-width: 0px;
}
.of-card-table tbody td {
  padding-bottom: 8px;
}
.of-card-table tbody tr {
  border-bottom: 1px solid rgb(222, 225, 225);
}
.of-card-td-l {
  font-size: 13px;
  line-height: 21.3333px;
  font-weight: 400;
  padding: 8px;
  text-align: left;
  color: rgb(81, 94, 95);
}
.of-card-td-r {
  font-size: 13px;
  line-height: 21.3333px;
  padding: 8px;
  text-align: right;
  color: rgb(81, 94, 95);
  font-weight: 600;
}
.box-check-all {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  border-radius: 5px;
  border: 1px solid #ced4da;
  cursor: pointer;
}
.tm {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  list-style: none;
  margin-bottom: 0;
  padding: 0;
}
.tm > li:first-child a {
  margin-left: 0;
}
.tm > li > a {
  border: 2px solid #fff;
  display: block;
  height: 30px;
  width: 30px;
}
.tm img {
  width: 100%;
  border-radius: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/instagram/instagramScheduleOfficial/detail.vue